export default "/fonts/roboto-medium-webfont.woff?b075a42c73d47e92d3517dd25ae18141";